import { useEffect, useState } from 'react';
import { eventiService } from '../../lib/eventi/eventiService';
import { messaggioErrore } from '../../lib/eventi/errori';
import type { PostaAcquirente } from '../../lib/eventi/daSentire';
import type { BigliettoEvento } from '../../lib/eventi/tipi';

/**
 * Le email mandate a chi ha pagato i biglietti dell'evento, per acquirente.
 * Si rileggono insieme ai biglietti ("Leggi adesso", un biglietto rimandato):
 * chi apre la scheda vede lo stato di adesso. Se non si riescono a leggere,
 * la scheda funziona lo stesso e dice cosa non va.
 */
export function usePostaAcquirenti(eventoId: string, biglietti: BigliettoEvento[]) {
  const [posta, setPosta] = useState<Map<string, PostaAcquirente> | null>(null);
  const [errore, setErrore] = useState<string | null>(null);

  useEffect(() => {
    let attiva = true;
    eventiService.postaAcquirenti(eventoId).then(
      (letta) => {
        if (!attiva) return;
        setPosta(letta);
        setErrore(null);
      },
      (e: unknown) => {
        if (attiva) setErrore(messaggioErrore(e));
      },
    );
    return () => {
      attiva = false;
    };
  }, [eventoId, biglietti]);

  return { posta, errore };
}
